<template>
  <div class="section-index">
    <div class="section-desktop is-hidden-touch">
      <div class="rs-interact">
        <div class="rs-main" v-if="roadshow.rsType === 0 && !userinfo.id">
          <div class="relative-position" style="padding: 50px 0 80px">
            <div class="text-center">
              <p><img src="~@/assets/images/lock.svg" width="400" alt="" /></p>
              <div class="gologin-tips" style="background: rgba(255, 255, 255, 0.35)">
                <div class="font-md"><a-icon type="warning" class="v-mr-xs text-grey" />封闭式路演，互动交流前请先<b class="span-login" @click="openLoginModal(2)">登录</b></div>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-main columns is-desktop" v-else-if="!showMore">
          <div class="rs-interact-wrapper column is-two-thirds-desktop">
            <div class="rs-panel">
              <div class="rs-panel-header">
                <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>
                <div class="rs-panel-header-title">互动问答</div>
                <div class="rs-panel-header-extra">
                  <!-- <a-input-group class="rs-input-search" compact>
                    <a-select v-model="msgSearchRange">
                      <a-select-option value="speakerName">作者</a-select-option>
                      <a-select-option value="guest">嘉宾</a-select-option>
                      <a-select-option value="content">内容</a-select-option>
                    </a-select>
                  </a-input-group> -->
                  <a-input-search class="rs-input-search" placeholder="作者 / 内容" style="width: 200px" v-model="msgSearchKey" @search="handleMsgSearch" />
                </div>
              </div>
              <div class="rs-panel-body">
                <div class="search-tips" v-if="showMsgSearchKeyTips">
                  <div class="flex items-center">
                    <span class="v-mr-auto"
                      >搜索“{{ msgSearchKeyLoaded }}”，共 <b>{{ pagination.total }}</b> 条记录。</span
                    >
                    <span class="hover-line" @click="clearMsgSearch"><a-icon type="left" /> 返回</span>
                  </div>
                </div>
                <template v-if="msgList.length > 0">
                  <div class="rs-interact-content">
                    <div class="rs-msg-container" v-for="item in msgList" :key="item.speak.sp_id">
                      <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-desc flex items-center">
                            <div class="rs-msg-action">
                              <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                              <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                              <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                              >：
                            </div>
                            <span class="rs-msg-time">{{ item.speak.sp_datetime }}</span>
                          </div>
                          <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                        </div>
                      </div>
                      <template v-if="item.speak.sp_type === 0 && item.replies && item.replies.length">
                        <div class="rs-msg rs-msg-reply" v-for="reply in item.replies" :key="reply.re_id">
                          <div class="rs-msg-number"></div>
                          <div class="rs-msg-main">
                            <div class="rs-msg-desc flex items-center">
                              <div class="rs-msg-action">
                                <span class="rs-msg-people">{{ reply.g_name }}</span>
                                <span class="rs-msg-op op-reply">答</span>：
                              </div>
                              <span class="rs-msg-time">{{ reply.a_datetime }}</span>
                            </div>
                            <div class="rs-msg-content" v-html="$utils.convertToHtml(reply.a_content)"></div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="rs-pagination">
                    <div class="rs-pagination-wrapper">
                      <span class="font-sm"
                        >共 <b>{{ pagination.total }}</b> 条</span
                      >
                      <a-pagination
                        size="small"
                        show-size-changer
                        show-quick-jumper
                        :total="pagination.total"
                        :current.sync="pagination.pageNum"
                        :page-size="pagination.pageSize"
                        :page-size-options="['5', '10', '20', '30']"
                        @change="onPageChange"
                        @showSizeChange="onPageChange"
                      />
                    </div>
                  </div>
                </template>
                <div style="padding: 50px 0 450px" v-if="!msgLoading && msgList.length === 0">
                  <a-empty :image-style="{ height: '200px' }">
                    <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                    <span slot="description" class="text-grey">暂无记录</span>
                  </a-empty>
                </div>
              </div>
            </div>
          </div>
          <div class="rs-interact-users column is-hidden-touch">
            <template v-if="userinfo.type === 0">
              <!-- <a-affix :offset-top="0"> -->
              <!-- 嘉宾 -->
              <div class="rs-login-info">
                <div class="col">
                  <span>欢迎嘉宾</span><b class="v-mr-sm">{{ userinfo.realName || userinfo.userName }}</b>
                  <span class="span-login" @click="logout">退出</span>
                </div>
                <button class="rs-button mini button-primary" @click="openSpeakModal">我要发言</button>
              </div>
              <!-- </a-affix> -->
              <!-- 待答区 -->
              <div class="rs-panel">
                <div class="rs-panel-header">
                  <div class="rs-panel-header-title">
                    <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>待我回答的问题（{{ myUnrepliedPg.total }}）
                  </div>
                  <div class="rs-panel-header-extra">
                    <span class="hover-line" @click="showMoreMsg(1)">更多&raquo;</span>
                  </div>
                </div>
                <div class="rs-panel-body">
                  <div class="rs-interact-ask-content" style="max-height: 416px">
                    <div class="rs-msg-container" v-for="item in myUnrepliedList.slice(0, 4)" :key="item.speak.sp_id">
                      <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-desc flex items-center">
                            <div class="rs-msg-action">
                              <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                              <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                              <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                              >：
                            </div>
                            <!-- <span class="rs-msg-time">{{ item.ptime }}</span> -->
                          </div>
                          <div class="rs-msg-content ellipsis ellipsis-3-lines" :title="item.speak.sp_content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                          <div class="rs-msg-actions">
                            <button class="rs-button button-reply" @click="openReplyModal(item)">回答</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding: 20px 0" v-if="myUnrepliedList.length === 0">
                      <a-empty :image-style="{ height: '200px' }">
                        <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                        <span slot="description" class="text-grey">暂无记录</span>
                      </a-empty>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 已答区 -->
              <div class="rs-panel">
                <div class="rs-panel-header">
                  <div class="rs-panel-header-title">
                    <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>我已回答的问题（{{ myRepliedPg.total }}）
                  </div>
                  <div class="rs-panel-header-extra">
                    <span class="hover-line" @click="showMoreMsg(2)">更多&raquo;</span>
                  </div>
                </div>
                <div class="rs-panel-body">
                  <div class="rs-interact-ask-content" style="max-height: 543px">
                    <div class="rs-msg-container" v-for="item in myRepliedList.slice(0, 4)" :key="item.speak.sp_id">
                      <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-desc flex items-center">
                            <div class="rs-msg-action">
                              <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                              <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                              <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                              >：
                            </div>
                            <!-- <span class="rs-msg-time">{{ item.ptime }}</span> -->
                          </div>
                          <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                        </div>
                      </div>
                      <template v-if="item.speak.sp_type === 0 && item.replies && item.replies.length">
                        <div class="rs-msg rs-msg-reply" v-for="(reply, index) in item.replies" :key="reply.re_id">
                          <div class="rs-msg-number"></div>
                          <div class="rs-msg-main">
                            <div class="rs-msg-action">
                              <span class="rs-msg-people">{{ reply.g_name }}</span>
                              <span class="rs-msg-op op-reply">答</span>：
                            </div>
                            <div class="rs-msg-content" v-html="$utils.convertToHtml(reply.a_content)"></div>
                            <div class="rs-msg-actions" v-if="index === item.replies.length - 1">
                              <button class="rs-button button-append" @click="openReplyModal(item)">追加回答</button>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div style="padding: 20px 0" v-if="myRepliedList.length === 0">
                      <a-empty :image-style="{ height: '200px' }">
                        <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                        <span slot="description" class="text-grey">暂无记录</span>
                      </a-empty>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="userinfo.type === 3">
              <!-- 用户 -->
              <div class="rs-login-info">
                <span class="col"
                  >欢迎用户，<b class="text-line hover-line" @click="openLoginModal(1)">{{ userinfo.realName || userinfo.userName }}</b></span
                >
                <button class="rs-button mini button-primary" @click="logout">退出</button>
              </div>
              <!-- 待答区 -->
              <div class="rs-panel">
                <div class="rs-panel-header">
                  <div class="rs-panel-header-title">
                    <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>待答区
                  </div>
                  <div class="rs-panel-header-extra">
                    <!-- <a-input-group class="rs-input-search" compact>
                      <a-select v-model="unrepliedSearchRange">
                        <a-select-option value="speakerName">作者</a-select-option>
                        <a-select-option value="guest">嘉宾</a-select-option>
                        <a-select-option value="content">内容</a-select-option>
                      </a-select>
                    </a-input-group> -->
                    <a-input-search class="rs-input-search" placeholder="作者 / 内容" style="width: 150px" v-model="unrepliedSearchKey" @search="handleUnrepliedSearch" />
                  </div>
                </div>
                <div class="rs-panel-body">
                  <div class="search-tips" v-if="showUnrepliedSearchKeyTips">
                    <div class="flex items-center">
                      <span class="v-mr-auto"
                        >搜索“{{ unrepliedSearchKeyLoaded }}”，共 <b>{{ unrepliedPg.total }}</b> 条记录。</span
                      >
                      <span class="hover-line" @click="clearUnrepliedSearch"><a-icon type="left" /> 返回</span>
                    </div>
                  </div>
                  <div class="rs-interact-ask-content">
                    <div class="rs-msg-container" v-for="item in unrepliedList" :key="item.speak.sp_id">
                      <div class="rs-msg rs-msg-ask">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-action">
                            <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                            <span class="rs-msg-op op-ask">问</span>
                            <span class="rs-msg-people">{{ item.speak.sp_guest }}</span
                            >：
                          </div>
                          <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rs-pagination" v-if="unrepliedPg.total > 0">
                    <div class="rs-pagination-wrapper">
                      <a-pagination
                        size="small"
                        show-less-items
                        show-quick-jumper
                        :total="unrepliedPg.total"
                        :current.sync="unrepliedPg.pageNum"
                        :page-size="unrepliedPg.pageSize"
                        @change="onUnrepliedPageChange"
                        @showSizeChange="onUnrepliedPageChange"
                      />
                    </div>
                  </div>
                  <div style="padding: 20px 0" v-else-if="unrepliedPg.total === 0">
                    <a-empty :image-style="{ height: '200px' }">
                      <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                      <span slot="description" class="text-grey">暂无记录</span>
                    </a-empty>
                  </div>
                </div>
              </div>
              <!-- 提问区 -->
              <div class="rs-panel">
                <div class="rs-panel-header">
                  <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>
                  <div class="rs-panel-header-title">我要提问</div>
                </div>
                <div class="rs-panel-body">
                  <div class="msg-form">
                    <div class="msg-form-control flex items-center">
                      <a-select
                        class="rs-select"
                        :class="[`rs-select-${roadshow.styleType}`]"
                        dropdown-class-name="rs-select-dropdown rs-select-right w250"
                        v-model="userSpeakForm.spGuestId"
                        placeholder="选择提问嘉宾"
                        style="width: 250px; margin-right: 12px"
                        allow-clear
                      >
                        <a-select-option :key="item.gId" :value="item.gId" v-for="item in guests" :title="`${item.gName}${item.gPost ? '（' + item.gPost + '）' : ''}`">
                          <b>{{ item.gName }}</b
                          ><template v-if="item.gPost">（{{ item.gPost }}）</template>
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="msg-form-control flex items-center v-my-md relative-position" ref="userSpContainer">
                      <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                      <div class="textarea-tips" v-if="userSpeakFormContentLen <= 500">
                        还可输入<b>{{ 500 - userSpeakFormContentLen }}</b
                        >字
                      </div>
                      <div class="textarea-tips text-red" v-else>
                        内容已超出<b>{{ userSpeakFormContentLen - 500 }}</b
                        >字
                      </div>
                    </div>
                    <div class="msg-form-actions">
                      <a-space :size="12">
                        <a-button type="primary" class="rs-button button-primary" :loading="userSpeakSaving" @click="handleSumbitUserSpeak">确认提交</a-button>
                        <button class="rs-button button-reset" @click="userSpeakForm.spContent = ''">重置</button>
                      </a-space>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- 未登录或其他用户 -->
              <!-- 待答区 -->
              <div class="rs-panel">
                <div class="rs-panel-header">
                  <div class="rs-panel-header-title">
                    <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>待答区
                  </div>
                  <div class="rs-panel-header-extra">
                    <!-- <a-input-group class="rs-input-search" compact>
                      <a-select v-model="unrepliedSearchRange">
                        <a-select-option value="speakerName">作者</a-select-option>
                        <a-select-option value="guest">嘉宾</a-select-option>
                        <a-select-option value="content">内容</a-select-option>
                      </a-select>
                    </a-input-group> -->
                    <a-input-search class="rs-input-search" placeholder="作者 / 内容" style="width: 150px" v-model="unrepliedSearchKey" @search="handleUnrepliedSearch" />
                  </div>
                </div>
                <div class="rs-panel-body">
                  <div class="search-tips" v-if="showUnrepliedSearchKeyTips">
                    <div class="flex items-center">
                      <span class="v-mr-auto"
                        >搜索“{{ unrepliedSearchKeyLoaded }}”，共 <b>{{ unrepliedPg.total }}</b> 条记录。</span
                      >
                      <span class="hover-line" @click="clearUnrepliedSearch"><a-icon type="left" /> 返回</span>
                    </div>
                  </div>
                  <div class="rs-interact-ask-content">
                    <div class="rs-msg-container" v-for="item in unrepliedList" :key="item.speak.sp_id">
                      <div class="rs-msg rs-msg-ask">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-action">
                            <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                            <span class="rs-msg-op op-ask">问</span>
                            <span class="rs-msg-people">{{ item.speak.sp_guest }}</span
                            >：
                          </div>
                          <div class="rs-msg-content ellipsis ellipsis-3-lines" :title="item.speak.sp_content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rs-pagination" v-if="unrepliedPg.total > 0">
                    <div class="rs-pagination-wrapper">
                      <a-pagination
                        size="small"
                        show-less-items
                        show-quick-jumper
                        :total="unrepliedPg.total"
                        :current.sync="unrepliedPg.pageNum"
                        :page-size="unrepliedPg.pageSize"
                        @change="onUnrepliedPageChange"
                        @showSizeChange="onUnrepliedPageChange"
                      />
                    </div>
                  </div>
                  <div style="padding: 20px 0" v-else-if="unrepliedPg.total === 0">
                    <a-empty :image-style="{ height: '200px' }">
                      <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                      <span slot="description" class="text-grey">暂无记录</span>
                    </a-empty>
                  </div>
                </div>
              </div>
              <!-- 提问区 -->
              <div class="rs-panel">
                <div class="rs-panel-header">
                  <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>
                  <div class="rs-panel-header-title">我要提问</div>
                </div>
                <div class="rs-panel-body" v-if="roadshow.rsState === 0">
                  <div class="msg-form">
                    <div class="msg-form-control flex items-center v-mb-md relative-position" ref="userSpContainer">
                      <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                      <div class="gologin-tips">
                        <div class="text-grey"><a-icon type="warning" class="v-mr-xs" />路演已结束</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rs-panel-body" v-else-if="roadshow.rsType === 0">
                  <div class="msg-form">
                    <div class="msg-form-control flex items-center v-mb-md relative-position" ref="userSpContainer">
                      <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                      <div class="gologin-tips">
                        <div><a-icon type="warning" class="v-mr-xs text-grey" />向嘉宾提问，请先<span class="span-login" @click="openLoginModal(2)">登录</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rs-panel-body" v-else>
                  <div class="flex items-center ls-1 font-sm">
                    <span class=""
                      ><b>{{ userSpeakerName }}</b
                      >，您好！</span
                    >
                    <span class="span-login" @click="openLoginModal(2)">登录</span>
                  </div>
                  <div class="msg-form">
                    <div class="msg-form-control flex items-center v-mt-sm font-sm">
                      <a-input v-model="userSpeakForm.spSpeakerName" style="width: 200px; margin-right: 12px" placeholder="输入您的昵称" /> 向
                    </div>

                    <div class="msg-form-control flex items-center v-my-md font-sm">
                      <a-select
                        class="rs-select"
                        :class="[`rs-select-${roadshow.styleType}`]"
                        :dropdown-class-name="`rs-select-dropdown rs-select-right rs-select-dropdown-${roadshow.styleType}`"
                        v-model="userSpeakForm.spGuestId"
                        placeholder="选择提问嘉宾"
                        style="width: 200px; margin-right: 12px"
                      >
                        <a-select-option :key="item.gId" :value="item.gId" v-for="item in guests" :title="`${item.gName}${item.gPost ? '（' + item.gPost + '）' : ''}`">
                          <b>{{ item.gName }}</b
                          ><template v-if="item.gPost">（{{ item.gPost }}）</template>
                        </a-select-option>
                      </a-select>
                      提问：
                    </div>
                    <div class="msg-form-control flex items-center v-my-md relative-position" ref="userSpContainer">
                      <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                      <div class="textarea-tips" v-if="userSpeakFormContentLen <= 500">
                        还可输入<b>{{ 500 - userSpeakFormContentLen }}</b
                        >字
                      </div>
                      <div class="textarea-tips text-red" v-else>
                        内容已超出<b>{{ userSpeakFormContentLen - 500 }}</b
                        >字
                      </div>
                    </div>
                    <div class="msg-form-actions">
                      <a-space :size="12">
                        <a-button type="primary" class="rs-button button-primary" :loading="userSpeakSaving" @click="handleSumbitUserSpeak">确认提交</a-button>
                        <button class="rs-button button-reset" @click="userSpeakForm.spContent = ''">重置</button>
                      </a-space>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="rs-main flex" v-else>
          <div class="rs-interact-wrapper rs-interact-usermsgs">
            <!-- 嘉宾 -->
            <!-- <div class="rs-login-info" style="width: 300px">
              <span class="col">欢迎嘉宾<b class="v-ml-sm">吴书兵</b></span>
              <button class="rs-button mini button-primary" @click="openSpeakModal">我要发言</button>
            </div> -->
            <div class="flex items-center">
              <div class="rs-login-info" style="width: 300px">
                <div class="col">
                  <span>欢迎嘉宾</span><b class="v-mr-sm">{{ userinfo.realName || userinfo.userName }}</b>
                  <span class="span-login" @click="logout">退出</span>
                </div>
                <button class="rs-button mini button-primary" @click="openSpeakModal">我要发言</button>
              </div>
              <span class="hover-line v-ml-auto flex items-center cursor-pointer" @click="backToIndex">&laquo;&nbsp;返回</span>
            </div>
            <!-- 待答区 -->
            <div class="rs-panel">
              <div class="rs-panel-header">
                <div class="rs-panel-header-title cursor-pointer" :class="{ 'text-grey': showTab === 2 }" @click="showTab = 1" title="待我回答的问题">
                  <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>待我回答的问题（{{ myUnrepliedPg.total }}）
                </div>
                <!-- <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span> -->
                <div class="rs-panel-header-title cursor-pointer" :class="{ 'text-grey': showTab === 1 }" @click="showTab = 2" title="我已回答的问题">
                  <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>我已回答的问题（{{ myRepliedPg.total }}）
                </div>
                <div class="rs-panel-header-extra">
                  <a-input-search class="rs-input-search" placeholder="作者 / 内容" style="width: 200px" v-model="myUnrepliedSearchKey" @search="handleMySearch" v-if="showTab === 1" />
                  <a-input-search class="rs-input-search" placeholder="作者 / 内容" style="width: 200px" v-model="myRepliedSearchKey" @search="handleMySearch" v-else />
                </div>
              </div>
              <div class="rs-panel-body">
                <template v-if="showTab === 1">
                  <div class="search-tips" v-if="showMyUnrepliedSearchKeyTips">
                    <div class="flex items-center">
                      <span class="v-mr-auto"
                        >搜索“{{ myUnrepliedSearchKeyLoaded }}”，共 <b>{{ myUnrepliedPg.total }}</b> 条记录。</span
                      >
                      <span class="hover-line" @click="clearMyUnrepliedSearch"><a-icon type="left" /> 返回</span>
                    </div>
                  </div>
                  <div class="rs-interact-ask-content" style="max-height: 700px">
                    <div class="rs-msg-container" v-for="item in myUnrepliedList" :key="item.speak.sp_id">
                      <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-desc flex items-center">
                            <div class="rs-msg-action">
                              <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                              <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                              <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                              >：
                            </div>
                            <span class="rs-msg-time">{{ item.ptime }}</span>
                          </div>
                          <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                          <div class="rs-msg-actions">
                            <button class="rs-button button-reply" @click="openReplyModal(item)">回答</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rs-pagination" v-if="myUnrepliedPg.total > 0">
                    <div class="rs-pagination-wrapper">
                      <a-pagination
                        size="small"
                        show-quick-jumper
                        show-size-changer
                        :current.sync="myUnrepliedPg.pageNum"
                        :total="myUnrepliedPg.total"
                        :page-size="myUnrepliedPg.pageSize"
                        :page-size-options="['5', '10', '20', '30']"
                        @change="onMyUnrepliedPageChange"
                        @showSizeChange="onMyUnrepliedPageChange"
                      />
                    </div>
                  </div>
                  <div style="padding: 20px 0" v-else-if="myUnrepliedPg.total === 0">
                    <a-empty :image-style="{ height: '200px' }">
                      <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                      <span slot="description" class="text-grey">暂无记录</span>
                    </a-empty>
                  </div>
                </template>
                <template v-else-if="showTab === 2">
                  <div class="search-tips" v-if="showMyRepliedSearchKeyTips">
                    <div class="flex items-center">
                      <span class="v-mr-auto"
                        >搜索“{{ myRepliedSearchKeyLoaded }}”，共 <b>{{ myRepliedPg.total }}</b> 条记录。</span
                      >
                      <span class="hover-line" @click="clearMyRepliedSearch"><a-icon type="left" /> 返回</span>
                    </div>
                  </div>
                  <div class="rs-interact-ask-content" style="max-height: 700px">
                    <div class="rs-msg-container" v-for="item in myRepliedList" :key="item.speak.sp_id">
                      <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                        <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                        <div class="rs-msg-main">
                          <div class="rs-msg-desc flex items-center">
                            <div class="rs-msg-action">
                              <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                              <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                              <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                              >：
                            </div>
                            <span class="rs-msg-time">{{ item.ptime }}</span>
                          </div>
                          <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                        </div>
                      </div>
                      <template v-if="item.speak.sp_type === 0 && item.replies && item.replies.length">
                        <div class="rs-msg rs-msg-reply" v-for="(reply, index) in item.replies" :key="reply.re_id">
                          <div class="rs-msg-number"></div>
                          <div class="rs-msg-main">
                            <div class="rs-msg-desc flex items-center">
                              <div class="rs-msg-action">
                                <span class="rs-msg-people">{{ reply.g_name }}</span>
                                <span class="rs-msg-op op-reply">答</span>：
                              </div>
                              <span class="rs-msg-time">{{ reply.a_datetime }}</span>
                            </div>
                            <div class="rs-msg-content" v-html="$utils.convertToHtml(reply.a_content)"></div>
                            <div class="rs-msg-actions" v-if="index === item.replies.length - 1">
                              <button class="rs-button button-append" @click="openReplyModal(item)">追加回答</button>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="rs-pagination" v-if="myRepliedPg.total > 0">
                    <div class="rs-pagination-wrapper">
                      <a-pagination
                        size="small"
                        show-quick-jumper
                        show-size-changer
                        :total="myRepliedPg.total"
                        :current.sync="myRepliedPg.pageNum"
                        :page-size="myRepliedPg.pageSize"
                        :page-size-options="['5', '10', '20', '30']"
                        @change="onMyRepliedPageChange"
                        @showSizeChange="onMyRepliedPageChange"
                      />
                    </div>
                  </div>
                  <div style="padding: 20px 0" v-else-if="myRepliedList.length === 0">
                    <a-empty :image-style="{ height: '200px' }">
                      <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
                      <span slot="description" class="text-grey">暂无记录</span>
                    </a-empty>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-touch is-hidden-desktop">
      <div class="rs-main" v-if="roadshow.rsType === 0 && !userinfo.id">
        <div class="relative-position" style="padding: 20px 0 80px">
          <div class="text-center">
            <p><img src="~@/assets/images/lock.svg" width="300" alt="" /></p>
            <div class="gologin-tips" style="background: rgba(255, 255, 255, 0.35)">
              <div class="font-md"><a-icon type="warning" class="v-mr-xs text-grey" />封闭式路演，互动交流前请先<b class="span-login" @click="openLoginModal(2)">登录</b></div>
            </div>
          </div>
        </div>
      </div>
      <van-tabs ref="vTabs" v-model="touchMsgTab" sticky swipeable v-else>
        <van-tab name="published">
          <span slot="title"><a-icon type="message" class="v-mr-xs font-sm text-theme" />互动问答</span>
          <van-search class="van-hairline--top" v-model="msgSearchKey" placeholder="请输入搜索关键词" @search="onSearchMsg" />
          <div class="search-tips" v-if="showMsgSearchKeyTips">
            <div class="flex items-center">
              <span class="v-mr-auto"
                >搜索“{{ msgSearchKeyLoaded }}”，共 <b>{{ pagination.total }}</b> 条记录。</span
              >
              <span class="hover-line" @click="clearMsgSearch"><a-icon type="left" /> 返回</span>
            </div>
          </div>
          <template v-if="msgAllList.length > 0">
            <div class="rs-interact-content">
              <div class="rs-msg-container" v-for="item in msgAllList" :key="item.speak.sp_id">
                <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                  <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                  <div class="rs-msg-main">
                    <div class="rs-msg-desc flex items-center">
                      <div class="rs-msg-action">
                        <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                        <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                        <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                        >：
                      </div>
                      <span class="rs-msg-time">{{ item.speak.sp_datetime ? item.speak.sp_datetime.substring(0, 16) : '' }}</span>
                    </div>
                    <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                  </div>
                </div>
                <template v-if="item.speak.sp_type === 0 && item.replies && item.replies.length">
                  <div class="rs-msg rs-msg-reply" v-for="reply in item.replies" :key="reply.re_id">
                    <div class="rs-msg-number"></div>
                    <div class="rs-msg-main">
                      <div class="rs-msg-desc flex items-center">
                        <div class="rs-msg-action">
                          <span class="rs-msg-people">{{ reply.g_name }}</span>
                          <span class="rs-msg-op op-reply">答</span>：
                        </div>
                        <span class="rs-msg-time">{{ reply.a_datetime ? reply.a_datetime.substring(0, 16) : '' }}</span>
                      </div>
                      <div class="rs-msg-content" v-html="$utils.convertToHtml(reply.a_content)"></div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div style="padding: 40px 0" v-if="!msgLoading && msgAllList.length === 0">
            <a-empty :image-style="{ height: '200px' }">
              <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
              <span slot="description" class="text-grey">暂无记录</span>
            </a-empty>
          </div>
        </van-tab>
        <van-tab name="unreplied" v-if="userinfo.type !== 0">
          <span slot="title"><a-icon type="question-circle" class="v-mr-xs font-sm text-theme" />待答区</span>
          <van-search class="van-hairline--top" v-model="unrepliedSearchKey" placeholder="请输入搜索关键词" @search="onSearchUnreplied" />
          <div class="search-tips" v-if="showUnrepliedSearchKeyTips">
            <div class="flex items-center">
              <span class="v-mr-auto"
                >搜索“{{ unrepliedSearchKeyLoaded }}”，共 <b>{{ unrepliedPg.total }}</b> 条记录。</span
              >
              <span class="hover-line" @click="clearUnrepliedSearch"><a-icon type="left" /> 返回</span>
            </div>
          </div>
          <template v-if="unrepliedAllList.length > 0">
            <div class="rs-interact-content">
              <div class="rs-msg-container" v-for="item in unrepliedAllList" :key="item.speak.sp_id">
                <div class="rs-msg rs-msg-ask">
                  <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                  <div class="rs-msg-main">
                    <div class="rs-msg-desc flex items-center">
                      <div class="rs-msg-action">
                        <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                        <span class="rs-msg-op op-ask">问</span>
                        <span class="rs-msg-people">{{ item.speak.sp_guest }}</span
                        >：
                      </div>
                      <span class="rs-msg-time">{{ item.speak.sp_datetime ? item.speak.sp_datetime.substring(0, 16) : '' }}</span>
                    </div>
                    <div class="rs-msg-content ellipsis ellipsis-3-lines" :title="item.speak.sp_content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div style="padding: 40px 0" v-else>
            <a-empty :image-style="{ height: '200px' }">
              <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
              <span slot="description" class="text-grey">暂无记录</span>
            </a-empty>
          </div>
        </van-tab>
        <van-tab name="myUnreplied" v-if="userinfo.type === 0">
          <span slot="title"><a-icon type="question-circle" class="v-mr-xs font-sm text-theme" />待我回答</span>
          <van-search class="van-hairline--top" v-model="myUnrepliedSearchKey" placeholder="请输入搜索关键词" @search="onSearchMyUnreplied" />
          <div class="search-tips" v-if="showMyUnrepliedSearchKeyTips">
            <div class="flex items-center">
              <span class="v-mr-auto"
                >搜索“{{ myUnrepliedSearchKeyLoaded }}”，共 <b>{{ myUnrepliedPg.total }}</b> 条记录。</span
              >
              <span class="hover-line" @click="clearMyUnrepliedSearch"><a-icon type="left" /> 返回</span>
            </div>
          </div>
          <template v-if="myUnrepliedListAll.length > 0">
            <div class="rs-interact-content">
              <div class="rs-msg-container" v-for="item in myUnrepliedList.slice(0, 4)" :key="item.speak.sp_id">
                <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                  <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                  <div class="rs-msg-main">
                    <div class="rs-msg-desc flex items-center">
                      <div class="rs-msg-action">
                        <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                        <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                        <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                        >：
                      </div>
                      <span class="rs-msg-time">{{ item.speak.sp_datetime ? item.speak.sp_datetime.substring(0, 16) : '' }}</span>
                    </div>
                    <div class="rs-msg-content ellipsis ellipsis-3-lines" :title="item.speak.sp_content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                    <div class="rs-msg-actions">
                      <button class="rs-button button-reply" @click="openReplyModal(item)">回答</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div style="padding: 40px 0" v-else>
            <a-empty :image-style="{ height: '200px' }">
              <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
              <span slot="description" class="text-grey">暂无记录</span>
            </a-empty>
          </div>
        </van-tab>
        <van-tab name="myReplied" v-if="userinfo.type === 0">
          <span slot="title"><a-icon type="alert" class="v-mr-xs font-sm text-theme" />我已回答</span>
          <van-search class="van-hairline--top" v-model="myRepliedSearchKey" placeholder="请输入搜索关键词" @search="onSearchMyReplied" />
          <div class="search-tips" v-if="showMyRepliedSearchKeyTips">
            <div class="flex items-center">
              <span class="v-mr-auto"
                >搜索“{{ myRepliedSearchKeyLoaded }}”，共 <b>{{ myRepliedPg.total }}</b> 条记录。</span
              >
              <span class="hover-line" @click="clearMyRepliedSearch"><a-icon type="left" /> 返回</span>
            </div>
          </div>
          <template v-if="myRepliedListAll.length > 0">
            <div class="rs-interact-content">
              <div class="rs-msg-container" v-for="item in myRepliedList.slice(0, 4)" :key="item.speak.sp_id">
                <div class="rs-msg" :class="[item.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', item.speak.sp_type === 0 && item.replies && item.replies.length ? 'has-reply' : '']">
                  <div class="rs-msg-number">{{ item.speak.sp_number }}</div>
                  <div class="rs-msg-main">
                    <div class="rs-msg-desc flex items-center">
                      <div class="rs-msg-action">
                        <span class="rs-msg-people">{{ item.speak.sp_speaker_name }}</span>
                        <span class="rs-msg-op op-ask" v-if="item.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                        <span v-if="item.speak.sp_type === 0">{{ item.speak.sp_guest }}</span
                        >：
                      </div>
                      <span class="rs-msg-time">{{ item.speak.sp_datetime ? item.speak.sp_datetime.substring(0, 16) : '' }}</span>
                    </div>
                    <div class="rs-msg-content" v-html="$utils.convertToHtml(item.speak.sp_content)"></div>
                  </div>
                </div>
                <template v-if="item.speak.sp_type === 0 && item.replies && item.replies.length">
                  <div class="rs-msg rs-msg-reply" v-for="(reply, index) in item.replies" :key="reply.re_id">
                    <div class="rs-msg-number"></div>
                    <div class="rs-msg-main">
                      <div class="rs-msg-desc flex items-center">
                        <div class="rs-msg-action">
                          <span class="rs-msg-people">{{ reply.g_name }}</span>
                          <span class="rs-msg-op op-reply">答</span>：
                        </div>
                        <span class="rs-msg-time">{{ reply.a_datetime ? reply.a_datetime.substring(0, 16) : '' }}</span>
                      </div>
                      <div class="rs-msg-content" v-html="$utils.convertToHtml(reply.a_content)"></div>
                      <div class="rs-msg-actions" v-if="index === item.replies.length - 1">
                        <button class="rs-button button-append" @click="openReplyModal(item)">追加回答</button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div style="padding: 40px 0" v-else>
            <a-empty :image-style="{ height: '200px' }">
              <span slot="image"><img src="~@/assets/images/msg.svg" /></span>
              <span slot="description" class="text-grey">暂无记录</span>
            </a-empty>
          </div>
        </van-tab>
      </van-tabs>
      <template v-if="showSpeakButton">
        <!-- 封闭式路演登录 -->
        <div class="rs-button-bottom fixed shadow" @click="openLoginModalFromMsgPopup(2)" v-if="roadshow.rsType === 0 && !userinfo.id">
          <div class="flex items-center justify-center"><a-icon type="export" style="font-size: 20px" class="v-mr-sm" />我要登录</div>
        </div>
        <!-- 嘉宾发言 -->
        <div class="rs-button-bottom fixed shadow" @click="openSpeakModal" v-else-if="userinfo.type === 0 && roadshow.rsState === 1">
          <div class="flex items-center justify-center"><img src="~@/assets/images/icon_msg.png" width="20" class="v-mr-sm" />我要发言</div>
        </div>
        <!-- 游客/会员提问 -->
        <div class="rs-button-bottom fixed shadow" @click="openMsgPopup" v-else-if="(!userinfo.id || userinfo.type === 3) && roadshow.rsState === 1">
          <div class="flex items-center justify-center"><img src="~@/assets/images/icon_msg.png" width="20" class="v-mr-sm" />我要提问</div>
        </div>
      </template>
      <van-popup v-model="msgPopup" position="bottom" closeable>
        <div class="rs-button-bottom">
          <div class="flex items-center justify-center"><img src="~@/assets/images/icon_msg.png" width="20" class="v-mr-sm" />我要提问</div>
        </div>
        <div class="msg-popup-contaner">
          <div class="flex items-center ls-1 font-sm" v-if="!userinfo.id">
            <span class=""
              ><b>{{ userSpeakerName }}</b
              >，您好！</span
            >
            <span class="span-login" @click="openLoginModalFromMsgPopup(2)">登录</span>
          </div>
          <div class="flex items-center ls-1 font-sm" v-else-if="userinfo.type === 3">
            <span class=""
              ><b>{{ userinfo.realName || userinfo.userName }}</b
              >，您好！</span
            >
            <span class="span-login" @click="logoutModalFromMsgPopup()">退出</span>
          </div>
          <div class="msg-form-control flex items-center v-mt-sm" v-if="!userinfo.id">
            <a-input v-model="userSpeakForm.spSpeakerName" style="width: 200px; margin-right: 12px" placeholder="输入您的昵称" /> 向
          </div>

          <div class="msg-form-control flex items-center v-my-md">
            <div class="rs-select ant-select ant-select-enabled rs-select-blue" style="width: 200px; margin-right: 12px" @click="showGuestPicker = true">
              <div role="combobox" class="ant-select-selection ant-select-selection--single">
                <div class="ant-select-selection__rendered">
                  <div unselectable="on" class="ant-select-selection__placeholder" style="display: block; user-select: none">
                    <span class="text-grey-7" v-if="userSpeakForm.spGuestId">{{ userSpeakForm.spGuest }}{{ userSpeakForm.spGuestPost ? '（' + userSpeakForm.spGuestPost + '）' : '' }}</span>
                    <span v-else>选择提问嘉宾</span>
                  </div>
                </div>
                <span unselectable="on" class="ant-select-arrow" style="user-select: none"><a-icon type="down" /></span>
              </div>
            </div>
            <span v-if="!userinfo.id">提问：</span>
          </div>
          <div class="msg-form-control v-my-md">
            <a-textarea placeholder="提问内容" v-model="userSpeakForm.spContent" :auto-size="{ minRows: 8, maxRows: 8 }" />
            <div class="textarea-tips" v-if="userSpeakFormContentLen <= 500">
              还可输入<b>{{ 500 - userSpeakFormContentLen }}</b
              >字
            </div>
            <div class="textarea-tips text-red" v-else>
              内容已超出<b>{{ userSpeakFormContentLen - 500 }}</b
              >字
            </div>
          </div>
          <div class="msg-form-actions">
            <a-space :size="12">
              <a-button type="primary" class="rs-button button-primary" :loading="userSpeakSaving" @click="handleSumbitUserSpeak2">确认提交</a-button>
              <button class="rs-button button-reset" @click="userSpeakForm.spContent = ''">重置</button>
            </a-space>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showGuestPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="guests.map((item) => ({ text: `${item.gName}${item.gPost ? '（' + item.gPost + '）' : ''}`, ...item }))"
          @cancel="showGuestPicker = false"
          @confirm="onGuestPickerConfirm"
        />
      </van-popup>
    </div>
    <a-modal
      class="modal-speak"
      :class="[`modal-theme-${roadshow.styleType}`]"
      centered
      destroy-on-close
      :mask-closable="false"
      :visible="speakModal"
      :width="960"
      @cancel="closeSpeakModal"
      :footer="null"
      :body-style="{ padding: '24px 48px' }"
    >
      <div class="rs-panel" style="margin-top: 10px">
        <div class="rs-panel-header">
          <div class="rs-panel-header-title">
            <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>嘉宾发言
          </div>
        </div>
        <div class="rs-panel-body">
          <div class="rs-speak">
            <div class="rs-speak-input">
              <div class="rs-speak-target">
                <div class="rs-speak-tab">
                  <div class="rs-msg-action">
                    <span class="rs-msg-people"> {{ userinfo.post }} {{ userinfo.realName }}</span>
                    <span class="rs-msg-op op-speak">说</span>：
                  </div>
                </div>
              </div>
              <div class="rs-speak-textarea">
                <a-textarea v-model="speakForm.spContent" ref="spContent" placeholder="输入发言内容..." :auto-size="{ minRows: 6, maxRows: 10 }" />
                <div class="textarea-tips">
                  还可输入<span>{{ 2000 - speakFormContentLen }}</span
                  >字
                </div>
              </div>
            </div>
            <div class="rs-speak-actions">
              <a-space :size="12">
                <a-button type="primary" class="rs-button button-primary" @click="handleSaveSpeak" :disabled="speakFormContentLen > 2000" :loading="speakSaving">确认提交</a-button>
                <button class="rs-button button-reset" @click="clearSpContent">重置</button>
              </a-space>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <a-modal
      class="modal-reply"
      :class="[`modal-theme-${roadshow.styleType}`]"
      centered
      destroy-on-close
      :mask-closable="false"
      :visible="replyModal"
      :width="960"
      @cancel="closeReplyModal"
      :footer="null"
      :body-style="{ padding: '24px 48px' }"
    >
      <div class="rs-panel" style="margin-top: 10px">
        <div class="rs-panel-header">
          <div class="rs-panel-header-title">
            <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>嘉宾回答
          </div>
        </div>
        <div class="rs-panel-body">
          <div class="rs-speak">
            <div class="rs-speak-published">
              <div class="rs-msg-container" v-if="replyData && replyData.speak">
                <div
                  class="rs-msg"
                  :class="[replyData.speak.sp_type === 0 ? 'rs-msg-ask' : 'rs-msg-speak', replyData.speak.sp_type === 0 && replyData.replies && replyData.replies.length ? 'has-reply' : '']"
                >
                  <div class="rs-msg-number">{{ replyData.speak.sp_number }}</div>
                  <div class="rs-msg-main">
                    <div class="rs-msg-desc flex items-center">
                      <div class="rs-msg-action">
                        <span class="rs-msg-people">{{ replyData.speak.sp_speaker_name }}</span>
                        <span class="rs-msg-op op-ask" v-if="replyData.speak.sp_type === 0">问</span><span class="rs-msg-op op-speak" v-else>说</span>
                        <span v-if="replyData.speak.sp_type === 0">{{ replyData.speak.sp_guest }}</span
                        >：
                      </div>
                      <span class="rs-msg-time">{{ replyData.speak.sp_datetime }}</span>
                    </div>
                    <div class="rs-msg-content" v-html="$utils.convertToHtml(replyData.speak.sp_content)"></div>
                  </div>
                </div>
                <template v-if="replyData.speak.sp_type === 0 && replyData.replies && replyData.replies.length">
                  <div class="rs-msg rs-msg-reply" v-for="reply in replyData.replies" :key="reply.re_id">
                    <div class="rs-msg-number"></div>
                    <div class="rs-msg-main">
                      <div class="rs-msg-desc flex items-center">
                        <div class="rs-msg-action">
                          <span class="rs-msg-people">{{ reply.g_name }}</span>
                          <span class="rs-msg-op op-reply">答</span>：
                        </div>
                        <span class="rs-msg-time">{{ reply.ptime }}</span>
                      </div>
                      <div class="rs-msg-content" v-html="$utils.convertToHtml(reply.a_content)"></div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="rs-speak-input">
              <div class="rs-speak-target">
                <div class="rs-speak-tab tab-reply">
                  <div class="rs-msg-action">
                    <span class="rs-msg-people"> {{ userinfo.post }} {{ userinfo.realName }}</span>
                    <span class="rs-msg-op op-reply">答</span>：
                  </div>
                </div>
              </div>
              <div class="rs-speak-textarea">
                <a-textarea v-model="replyForm.acontent" ref="acontent" placeholder="输入回复内容..." :auto-size="{ minRows: 6, maxRows: 10 }" />
                <div class="textarea-tips" v-if="replyFormContentLen <= 2000">
                  还可输入<b>{{ 2000 - replyFormContentLen }}</b
                  >字
                </div>
                <div class="textarea-tips text-red" v-else>
                  内容已超出<b>{{ replyFormContentLen - 2000 }}</b
                  >字
                </div>
              </div>
            </div>
            <div class="rs-speak-actions">
              <a-space :size="12">
                <a-button type="primary" class="rs-button button-primary" @click="handleSaveReply" :disabled="replyFormContentLen > 2000" :loading="replySaving">确认提交</a-button>
                <button class="rs-button button-reset" @click="clearAContent">重置</button>
              </a-space>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { listAll, saveSpeak, listSpeak, saveUserSpeak, saveReply, lockSpeak, getLockState } from '@/api/interact'
export default {
  name: 'RoadshowIndex',
  data() {
    return {
      rsId: this.$route.query.id,
      msgSearchRange: 'speakerName',
      msgSearchKey: '',
      msgSearchKeyLoaded: '',
      showMsgSearchKeyTips: false,
      unrepliedSearchRange: 'speakerName',
      unrepliedSearchKey: '',
      unrepliedSearchKeyLoaded: '',
      showUnrepliedSearchKeyTips: false,
      mySearchRange: 'speakerName',
      mySearchKey: '',
      mySearchKeyLoaded: '',
      showMySearchKeyTips: false,
      pagination: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
      },
      loginType: 1,
      msgLoading: false,
      msgList: [],
      unrepliedList: [],
      unrepliedPg: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
      },
      myRepliedList: [],
      myRepliedPg: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
      },
      myUnrepliedList: [],
      myUnrepliedPg: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
      },
      speakModal: false,
      speakForm: {
        spContent: '',
      },
      userSpeakerName: `游客${Math.random().toString().substring(2, 8)}`,
      userSpeakForm: {
        spGuestId: undefined,
        spGuest: '',
        spSpeakerName: '',
        spContent: '',
        spGuestPost: '',
      },
      userSpeakSaving: false,
      speakUser: {},
      speakSaving: false,
      replyData: {},
      replyModal: false,
      replySaving: false,
      replyForm: {
        acontent: '',
      },
      showMore: false,
      showTab: undefined,
      myMoreList: [],
      myUnrepliedTotal: 0,
      myRepliedTotal: 0,
      myMorePg: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
      },
      touchMsgTab: 'published',
      touchMsgList1: [],
      touchMsgLoading: false,
      touchMsgFinished: false,
      msgPopup: false,
      msgAllList: [],
      unrepliedAllList: [],
      showGuestPicker: false,
      showSpeakButton: true,
      myUnrepliedListAll: [],
      myRepliedListAll: [],
      myUnrepliedSearchKey: '',
      myUnrepliedSearchKeyLoaded: '',
      showMyUnrepliedSearchKeyTips: false,
      myRepliedSearchKey: '',
      myRepliedSearchKeyLoaded: '',
      showMyRepliedSearchKeyTips: false,
    }
  },
  computed: {
    userinfo: (vm) => vm.$store.state.user.userinfo,
    guests: (vm) => vm.$store.state.app.guests,
    roadshow: (vm) => vm.$store.state.app.roadshow,
    replyFormContentLen: (vm) => vm.replyForm.acontent.trim().length,
    speakFormContentLen: (vm) => vm.speakForm.spContent.trim().length,
    userSpeakFormContentLen: (vm) => vm.userSpeakForm.spContent.trim().length,
  },
  watch: {
    showTab(tab) {
      if (tab === 1) {
        this.loadMyUnreplied()
      } else if (tab === 2) {
        this.loadMyReplied()
      }
    },
    roadshow() {
      console.log('watch roadshow', this.roadshow)
      if (this.roadshow.rsId) {
        this.$nextTick(() => {
          this.$refs.vTabs && this.$refs.vTabs.resize()
        })
      }
    },
    $route() {
      this.rsId = this.$route.query.id
      this.loadAll()
    },
  },
  methods: {
    onSearchMsg() {
      this.loadPublished()
    },
    onSearchUnreplied() {
      this.loadUnreplied()
    },
    onSearchMyUnreplied() {
      this.loadMyUnreplied()
    },
    onSearchMyReplied() {
      this.loadMyReplied()
    },
    loadPublished(pageNum = 1, pageSize = 5) {
      let params = {
        rsId: this.rsId,
        mustAnswered: 1,
        fusionSearch: this.msgSearchKey.trim(),
      }
      // if (this.msgSearchKey.trim() !== '') {
      //   params[this.msgSearchRange] = this.msgSearchKey
      // }
      this.msgLoading = true
      listAll(params)
        .then(({ data }) => {
          if (data.success) {
            let list = data.result || []
            this.$utils.sortMsg(list)
            this.pagination = {
              pageNum,
              pageSize,
              total: list.length,
            }
            this.msgAllList = list
            this.msgList = list.slice((pageNum - 1) * pageSize, pageNum * pageSize)
            if (this.msgSearchKey.trim() !== '') {
              this.showMsgSearchKeyTips = true
            } else {
              this.showMsgSearchKeyTips = false
            }
            this.msgSearchKeyLoaded = this.msgSearchKey.trim()
          }
          this.msgLoading = false
        })
        .catch(() => {
          this.msgLoading = false
        })
      this.$root.$emit('statVisit', 2)
    },
    loadUnreplied(pageNum = 1, pageSize = 5) {
      let params = {
        rsId: this.rsId,
        type: 0,
        noAnswered: 1,
        fusionSearch: this.unrepliedSearchKey.trim(),
      }
      // if (this.unrepliedSearchKey.trim() !== '') {
      //   params[this.unrepliedSearchRange] = this.unrepliedSearchKey
      // }
      listSpeak(params).then(({ data }) => {
        if (data.success) {
          let list = data.result || []
          this.$utils.sortMsg(list)
          this.unrepliedPg = {
            pageNum,
            pageSize,
            total: list.length,
          }
          this.unrepliedAllList = list
          this.unrepliedList = list.slice((pageNum - 1) * pageSize, pageNum * pageSize)
          if (this.unrepliedSearchKey.trim() !== '') {
            this.showUnrepliedSearchKeyTips = true
          } else {
            this.showUnrepliedSearchKeyTips = false
          }
          this.unrepliedSearchKeyLoaded = this.unrepliedSearchKey.trim()
        }
      })
      this.$root.$emit('statVisit', 2)
    },
    handleSumbitUserSpeak() {
      let vm = this
      let { spGuestId, spSpeakerName, spContent, spGuest } = this.userSpeakForm
      // this.$message.destroy()
      if (spContent.trim() === '') {
        // this.$message.warning('请输入提问内容')
        this.$toast({
          message: '请输入提问内容',
          position: 'top',
          getContainer: () => this.$refs.userSpContainer,
        })
        this.$refs.userSpContent.focus()
        return
      }
      if (this.userSpeakFormContentLen > 500) {
        this.$toast({
          message: '提问内容字数太多啦',
          position: 'top',
        })
        return
      }
      if (spGuestId) {
        let guest = this.guests.find((g) => g.gId === spGuestId)
        spGuest = guest ? guest.gName : ''
      }
      if (spSpeakerName.trim() === '') {
        spSpeakerName = this.userSpeakerName
      }
      let params = {
        spGuest,
        spGuestId,
        spSpeakerName,
        spContent,
        rsId: this.rsId,
      }
      let { id, userName, realName } = this.userinfo
      if (id) {
        params.spSpeakerId = id
        params.spSpeakerName = realName || userName
      }
      this.userSpeakSaving = true
      saveUserSpeak(params)
        .then(({ data }) => {
          if (data.success) {
            this.$toast.success('提交成功')
            this.userSpeakForm.spContent = ''
            setTimeout(() => {
              let { pageNum, pageSize } = vm.unrepliedPg
              vm.loadUnreplied(pageNum, pageSize)
            }, 1000)
          } else {
            this.$toast.fail(data.msg || '提交失败，请重试')
          }
          this.userSpeakSaving = false
        })
        .catch(() => {
          this.$message.warning('提交失败，请重试')
          this.userSpeakSaving = false
        })
      this.$root.$emit('statVisit', 2)
    },
    onPageChange(pageNum, pageSize) {
      this.loadPublished(pageNum, pageSize)
    },
    onUnrepliedPageChange(pageNum, pageSize) {
      this.loadUnreplied(pageNum, pageSize)
    },
    onMyRepliedPageChange(pageNum, pageSize) {
      this.loadMyReplied(pageNum, pageSize)
    },
    onMyUnrepliedPageChange(pageNum, pageSize) {
      this.loadMyUnreplied(pageNum, pageSize)
    },
    loadMyUnreplied(pageNum = 1, pageSize = 5) {
      let params = {
        rsId: this.rsId,
        noAnswered: 1,
        type: 0,
        spGuestId: this.userinfo.id,
        fusionSearch: this.myUnrepliedSearchKey.trim(),
      }
      listSpeak(params).then(({ data }) => {
        if (data.success) {
          let list = data.result || []
          this.$utils.sortMsg(list)
          this.myUnrepliedPg = {
            pageNum,
            pageSize,
            total: list.length,
          }
          this.myUnrepliedListAll = list
          this.myUnrepliedList = list.slice((pageNum - 1) * pageSize, pageNum * pageSize)
          if (this.myUnrepliedSearchKey.trim() !== '') {
            this.showMyUnrepliedSearchKeyTips = true
          } else {
            this.showMyUnrepliedSearchKeyTips = false
          }
          this.myUnrepliedSearchKeyLoaded = this.myUnrepliedSearchKey.trim()
        }
      })
      this.$root.$emit('statVisit', 2)
    },
    loadMyReplied(pageNum = 1, pageSize = 5) {
      let params = {
        rsId: this.rsId,
        mustAnswered: 1,
        type: 0,
        fusionSearch: this.myRepliedSearchKey.trim(),
        gId: this.userinfo.id,
      }
      listSpeak(params).then(({ data }) => {
        if (data.success) {
          let list = data.result || []
          this.$utils.sortMsg(list)
          this.myRepliedPg = {
            pageNum,
            pageSize,
            total: list.length,
          }
          this.myRepliedListAll = list
          this.myRepliedList = list.slice((pageNum - 1) * pageSize, pageNum * pageSize)
          if (this.myRepliedSearchKey.trim() !== '') {
            this.showMyRepliedSearchKeyTips = true
          } else {
            this.showMyRepliedSearchKeyTips = false
          }
          this.myRepliedSearchKeyLoaded = this.myRepliedSearchKey.trim()
        }
      })
      this.$root.$emit('statVisit', 2)
    },
    openLoginModal(type) {
      this.$root.$emit('openLoginModal', type)
      // this.$root.$emit('statVisit', 2)
    },
    openSpeakModal() {
      this.speakModal = true
      this.setSpeakButton(false)
      this.$root.$emit('statVisit', 2)
      // this.$parent.$emit('openSpeakModal', this.userinfo)
    },
    closeSpeakModal() {
      this.speakModal = false
      this.speakForm.spContent = ''
      this.setSpeakButton(true)
    },
    handleSaveSpeak() {
      let vm = this
      let { spContent } = vm.speakForm
      this.$message.destroy()
      if (spContent.trim() === '') {
        // this.$message.warning('请输入发言内容')
        this.$toast({
          message: '请输入发言内容',
          position: 'middle',
        })
        // this.$refs.spContent.focus()
        return
      }
      let { id, realName } = vm.userinfo
      let params = {
        spContent,
        spType: 1,
        spSpeakerId: id,
        rsId: this.rsId,
        spSpeakerName: realName,
      }
      console.log(params)
      vm.speakSaving = true
      saveSpeak(params)
        .then(({ data }) => {
          if (data.success) {
            vm.$toast.success('提交成功')
            vm.speakModal = false
            vm.speakForm.spContent = ''
            vm.setSpeakButton(true)
            setTimeout(() => {
              vm.loadAll()
            }, 1000)
          } else {
            vm.$toast.fail(data.msg)
          }
          vm.speakSaving = false
        })
        .catch(() => {
          // vm.$message.warning('提交失败，请重试')
          vm.speakSaving = false
        })
      this.$root.$emit('statVisit', 2)
    },
    handleSaveReply() {
      let vm = this
      let { acontent } = vm.replyForm
      this.$message.destroy()
      if (acontent.trim() === '') {
        // this.$message.warning('请输入回复内容')
        this.$toast({
          message: '请输入回复内容',
          position: 'middle',
        })
        // this.$refs.acontent.focus()
        return
      }
      let { id, userName, realName } = vm.userinfo
      let params = {
        acontent,
        rsId: this.rsId,
        gid: id,
        gname: realName || userName,
        spId: this.replyData.speak.sp_id,
      }
      console.log(params)
      vm.replySaving = true
      saveReply(params)
        .then(({ data }) => {
          if (data.success) {
            vm.$toast.success('提交成功')
            vm.closeReplyModal()
            setTimeout(() => {
              vm.loadAll()
            }, 1000)
          } else {
            vm.$toast.fail(data.msg)
          }
          vm.replySaving = false
        })
        .catch(() => {
          vm.replySaving = false
        })

      this.$root.$emit('statVisit', 2)
    },
    openReplyModal(item) {
      let vm = this
      vm.replyData = item
      getLockState(item.speak.sp_id)
        .then(({ data }) => {
          if (data.success) {
            let state = data.result
            if (state === 1) {
              vm.$toast.fail('问题已锁定')
            } else {
              lockSpeak(item.speak.sp_id, 1)
                .then(({ data }) => {
                  if (data.success) {
                    vm.setSpeakButton(false)
                    vm.replyModal = true
                  } else {
                    vm.$toast({
                      message: '问题锁定失败',
                      position: 'bottom',
                    })
                  }
                })
                .catch(() => {
                  vm.$toast.fail('问题锁定：服务器响应错误')
                })
            }
          } else {
            vm.$toast.fail('获取锁定状态失败：' + data.msg)
          }
        })
        .catch(() => {
          vm.$toast.fail('获取锁定状态：服务器响应错误')
        })
      this.$root.$emit('statVisit', 2)
    },
    closeReplyModal() {
      this.replyModal = false
      this.replyForm.acontent = ''
      this.setSpeakButton(true)
      let { speak } = this.replyData
      // 解锁问题
      lockSpeak(speak.sp_id, 0)
        .then(({ data }) => {
          if (!data.success) {
            this.$toast.fail('问题解锁失败')
          }
        })
        .catch(() => {
          this.$toast.fail('问题解锁失败：服务器响应错误')
        })
    },
    clearSpContent() {
      this.speakForm.spContent = ''
    },
    clearAContent() {
      this.replyForm.acontent = ''
    },
    logout() {
      this.$store.dispatch('logout')
    },
    showMoreMsg(showTab) {
      this.showMore = true
      this.showTab = showTab
    },
    handleMySearch() {
      if (this.showTab === 1) {
        this.loadMyUnreplied()
      } else if (this.showTab === 2) {
        this.loadMyReplied()
      }
    },
    handleUnrepliedSearch() {
      this.loadUnreplied()
    },
    handleMsgSearch() {
      this.loadPublished()
    },
    loadAll() {
      let { type } = this.userinfo
      // this.msgSearchKey = ''
      // this.unrepliedSearchKey
      this.loadPublished()
      if (type === 0) {
        // 嘉宾
        this.loadMyUnreplied()
        this.loadMyReplied()
      } else {
        // 其他用户
        this.loadUnreplied()
      }
      this.$root.$emit('statVisit')
    },
    backToIndex() {
      this.showMore = false
      this.showTab = undefined
      this.$root.$emit('statVisit', 2)
    },
    openMsgPopup() {
      this.userSpeakForm.spGuestId = undefined
      this.userSpeakForm.spGuest = ''
      this.userSpeakForm.spGuestPost = ''
      this.userSpeakForm.spContent = ''
      this.msgPopup = true
      this.$root.$emit('statVisit', 2)
    },
    onGuestPickerConfirm(item, index) {
      console.log('onGuestPickerConfirm', item, index)
      this.userSpeakForm.spGuestId = item.gId
      this.userSpeakForm.spGuest = item.gName
      this.userSpeakForm.spGuestPost = item.gPost
      this.showGuestPicker = false
    },
    handleSumbitUserSpeak2() {
      let vm = this
      let { spGuestId, spSpeakerName, spContent, spGuest } = this.userSpeakForm
      this.$message.destroy()
      if (spContent.trim() === '') {
        this.$toast({
          message: '请输入提问内容',
          position: 'bottom',
        })
        return
      }
      if (this.userSpeakFormContentLen > 500) {
        this.$toast({
          message: '提问内容字数太多啦',
          position: 'bottom',
        })
        return
      }
      if (spGuestId) {
        let guest = this.guests.find((g) => g.gId === spGuestId)
        spGuest = guest ? guest.gName : ''
      }
      if (spSpeakerName.trim() === '') {
        spSpeakerName = this.userSpeakerName
      }
      let params = {
        spGuest,
        spGuestId,
        spSpeakerName,
        spContent,
        rsId: this.rsId,
      }
      let { id, userName, realName } = this.userinfo
      if (id) {
        params.spSpeakerId = id
        params.spSpeakerName = realName || userName
      }
      this.userSpeakSaving = true
      saveUserSpeak(params)
        .then(({ data }) => {
          if (data.success) {
            this.$toast.success('提交成功')
            this.userSpeakForm.spContent = ''
            this.msgPopup = false
            setTimeout(() => {
              let { pageNum, pageSize } = vm.unrepliedPg
              vm.loadUnreplied(pageNum, pageSize)
            }, 1000)
          } else {
            this.$toast({
              message: data.msg,
              position: 'bottom',
            })
          }
          this.userSpeakSaving = false
        })
        .catch(() => {
          this.$toast({
            message: '提交失败，请重试',
            position: 'bottom',
          })
          this.userSpeakSaving = false
        })
      this.$root.$emit('statVisit', 2)
    },
    setSpeakButton(status = false) {
      this.showSpeakButton = status
    },
    openLoginModalFromMsgPopup(type) {
      this.msgPopup = false
      this.openLoginModal(type)
      // this.$root.$emit('statVisit', 2)
    },
    logoutModalFromMsgPopup() {
      this.$store.dispatch('logout')
      this.$root.$emit('statVisit', 2)
    },
    clearMsgSearch() {
      this.msgSearchKey = ''
      this.handleMsgSearch()
    },
    clearUnrepliedSearch() {
      this.unrepliedSearchKey = ''
      this.handleUnrepliedSearch()
    },
    clearMyUnrepliedSearch() {
      this.myUnrepliedSearchKey = ''
      this.loadMyUnreplied()
    },
    clearMyRepliedSearch() {
      this.myRepliedSearchKey = ''
      this.loadMyReplied()
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (!to.query.id) {
  //     location.href = errorURL
  //   } else {
  //     next()
  //   }
  // },
  created() {
    this.$root.$on('loadMyUnreplied', this.loadMyUnreplied)
    this.$root.$on('loadMyReplied', this.loadMyReplied)
    this.$root.$on('loadAll', this.loadAll)
    this.$root.$on('setSpeakButton', this.setSpeakButton)
  },
  mounted() {
    if (this.rsId) {
      this.loadPublished()
      this.loadUnreplied()
      let { type } = this.userinfo
      if (type === 0) {
        this.loadMyUnreplied()
        this.loadMyReplied()
      }
    }
  },
  // activated() {
  //   this.$root.$on('loadMyUnreplied', this.loadMyUnreplied)
  //   this.$root.$on('loadMyReplied', this.loadMyReplied)
  //   this.$root.$on('loadAll', this.loadAll)
  // },
  // destroyed() {
  //   this.$root.$off('loadMyUnreplied')
  //   this.$root.$off('loadMyReplied')
  //   this.$root.$off('loadAll')
  // },
}
</script>
